/**
 * PDA: κάρτα/IRIS του τραπεζιού που δεν κατέληξε σε πληρωμή, από τον server (utils/dineInCardDoubt) — φαίνεται
 * και μετά από ανανέωση του app, σε αντίθεση με το κλείδωμα αβέβαιης χρέωσης του PaymentScreen που ζει στη
 * μνήμη. Μόνο ένδειξη (25/10/2026).
 */

import React from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';
import { CardDoubt, cardDoubtText } from '../../../utils/dineInCardDoubt';

const CardDoubtBanner: React.FC<{ doubts: CardDoubt[] }> = ({ doubts }) => {
  if (doubts.length === 0) return null;
  return (
    <div className="space-y-2" data-testid="pda-card-doubt">
      {doubts.map((d) => {
        const { title, detail } = cardDoubtText(d);
        const running = d.state === 'in_flight';
        return (
          <div
            key={d.transactionId}
            role={running ? 'status' : 'alert'}
            data-testid={`pda-card-doubt-${d.state}`}
            className={`flex items-start gap-2 px-3 py-2 rounded-xl text-sm ${
              running
                ? 'bg-blue-50 dark:bg-blue-900/30 border border-blue-300 dark:border-blue-700/50 text-blue-900 dark:text-blue-200'
                : 'bg-red-50 dark:bg-red-900/30 border-2 border-red-500 dark:border-red-600 text-red-900 dark:text-red-200'
            }`}
          >
            {running
              ? <Loader2 className="w-5 h-5 shrink-0 mt-0.5 animate-spin" />
              : <AlertTriangle className="w-5 h-5 shrink-0 mt-0.5" />}
            <div className="space-y-1">
              <p className="font-bold">{title}</p>
              <p>{detail}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CardDoubtBanner;
